import { render, staticRenderFns } from "./list-icon.vue?vue&type=template&id=e3967c72&"
import script from "./list-icon.vue?vue&type=script&lang=js&"
export * from "./list-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/leads/icons/list-icon.vue
// module id = 1171
// module chunks = 0